import Preloader from "@/components/loading/Preloader"

/**
 * Full page loading screen : default loading.tsx of the zones, also displayed by the forms while sending
 */
export default function PageLoading() {
    // Wrapper in normal flow : Next skips `position: fixed` elements when applying the scroll to top after a navigation
    return (
        <div>
            <Preloader />
        </div>
    )
}
